import { SUBMIT_NCC_CHECK } from '.'
import * as api from '../api/nccBackgroundCheck'

/**
 * @param {string} uniqueLink - the Dasher Applicant unique link
 */
export const submitNccCheckRequest = (uniqueLink: string) => {
  return async dispatch => {
    try {
      dispatch({ type: SUBMIT_NCC_CHECK.IN_PROGRESS })

      const response = await api.submitNccCheck({
        applicantUniqueLink: uniqueLink,
      })

      dispatch({
        type: SUBMIT_NCC_CHECK.SUCCESS,
        payload: response,
      })
    } catch (error) {
      dispatch({ type: SUBMIT_NCC_CHECK.FAIL })
      console.warn(`[NccCheck] ${error}: ${uniqueLink}`)
    }
  }
}
